// import {createUrl} from "../../http";
// import AdditionalDocumentsService from "../../../../../services/IpadPreview/BeforeTake-off/FlightPlanning/additionaldocuments.service";
import {createUrl} from "../../../../../http";
var currentDateWithFormat = new Date().toISOString().slice(0, 10);

const state = {
    AttachmentFiles: [],
    AttachmentsByFKeygetters : [],
    searchDate: currentDateWithFormat,
    releaseModalUrl: createUrl("/Attachment/GetFlightReleaseByFlight/") ,  // 'https://localhost:44333/api/Attachment/GetFlightReleaseByFlight/'
};
const mutations = {
    set_json_data(state, payload) {
        state.jsonData = payload;
        state.samplevalue = "test";
    },

    set_AttachmentList_Flight(state,payload){
        if (payload.length) {
            state.AttachmentFiles = payload;
            state.samplevalue = "files";
        }
    }
};
const actions = {

};

const getters = {
    FillAttachmentstoDatagetters : state =>
    {
        let list= [];

        for ( let i =0; i< state.AttachmentFiles.length; i++)
        {
            list.push(state.AttachmentFiles[i]);
        }
            return list;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
